import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  width: {
    property: 'width'
  },
  height: {
    property: 'height'
  },
  minWidth: {
    property: 'minWidth'
  },
  maxWidth: {
    property: 'maxWidth'
  },
  minHeight: {
    property: 'minHeight'
  },
  maxHeight: {
    property: 'maxHeight'
  },
  display: {
    property: 'display'
  },
  verticalAlign: {
    property: 'verticalAlign'
  },
  overflow: {
    property: 'overflow'
  },
  overflowX: {
    property: 'overflowX'
  },
  overflowY: {
    property: 'overflowY'
  }
};
const layout = system(config);

export { layout };
